export const FEEDBACK_ACCEPTED = 'accepted'
export const FEEDBACK_REFUSED = 'refused'



// WEBPACK FOOTER //
// ./src/components/BidSessions/constants.js